export default __webpack_public_path__ + "static/chainlink-8a7e5241c4c5d5c4b0485e74aec74c4f.png";